export default "__VITE_ASSET__BQzXmw6j__"